// extracted by mini-css-extract-plugin
export default {"wrapper":"VacancyBanner_wrapper__a3Zoi","sliceBorder":"VacancyBanner_sliceBorder__grRta","background":"VacancyBanner_background__QHIvD","link":"VacancyBanner_link__nu4yh"};